import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import Pagination from "../../components/Pagination";
import ModalCampaignProjects from "../../components/campaign/ModalCampaignProjects";
import ModalDownloadCampaignVouchers from "../../components/campaign/ModalDownloadCampaignVouchers";
import { useCampaignDetail, useCampaignVouchers } from "../../utils/campaign/CampaignUtils";

export default function CampaignDetailPage() {
  const { id } = useParams();

  const {
    campaign,
    loading: loadingDetail,
    errorMsg: errorDetail,
  } = useCampaignDetail({ campaign_id: id });

  const [formFilter, setFormFilter] = useState({ q: "" });
  const [filter, setFilter] = useState({
    q: "",
    page: 1,
    page_size: 25,
  });

  const {
    vouchers,
    meta,
    loading: loadingVouchers,
    errorMsg: errorVouchers,
  } = useCampaignVouchers({ campaign_id: id, filter });

  const applyFilter = () => {
    let form_filter = { ...filter, ...formFilter, page: 1 };
    setFilter(form_filter);
  };

  const resetFilter = () => {
    setFormFilter({ q: "" });
    setFilter({ q: "", page: 1, page_size: 25 });
  };

  const [activeModal, setActiveModal] = useState(null);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="campaign">
      <div className="container-fluid">
        <BackToCampaignLink />
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Campaign Detail</h1>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12">
            <Box title="Informasi Campaign" loading={loadingDetail}>
              {errorDetail && <div className="alert alert-danger">{errorDetail}</div>}
              {campaign && (
                <>
                  <table className="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td width={200}>Nama</td>
                        <td>{campaign.name}</td>
                      </tr>
                      <tr>
                        <td>Slug</td>
                        <td>{campaign.slug}</td>
                      </tr>
                      <tr>
                        <td>Tambahan Masa Aktif</td>
                        <td>{campaign.extra_days} hari</td>
                      </tr>
                      <tr>
                        <td>Waktu Mulai</td>
                        <td>{moment(campaign.start_date).format("D MMMM YYYY")}</td>
                      </tr>
                      <tr>
                        <td>Waktu Akhir</td>
                        <td>{moment(campaign.end_date).format("D MMMM YYYY")}</td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td>
                          {campaign.is_active ? (
                            <span className="badge badge-success">Active</span>
                          ) : (
                            <span className="badge badge-secondary">Inactive</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Waktu Buat Campaign</td>
                        <td>{moment.unix(campaign.created_at).format("D MMMM YYYY HH:mm")}</td>
                      </tr>
                      <tr>
                        <td>Waktu Ubah Campaign Terakhir</td>
                        <td>
                          {campaign.updated_at
                            ? moment.unix(campaign.updated_at).format("D MMMM YYYY HH:mm")
                            : "-"}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <hr />
                  <h6 className="font-weight-bold mb-3">Statistik Voucher</h6>
                  <table className="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td width={200}>Voucher Diklaim</td>
                        <td>{campaign.issued_voucher_count}</td>
                      </tr>
                      <tr>
                        <td>Total Voucher</td>
                        <td>{campaign.total_voucher_count}</td>
                      </tr>
                      <tr>
                        <td>Persentase Voucher Terklaim</td>
                        <td>{campaign.issued_voucher_percentage}%</td>
                      </tr>
                    </tbody>
                  </table>

                  <hr />
                  <h6 className="font-weight-bold mb-3">Project</h6>
                  <div className="mb-3">
                    <button
                      className="btn btn-info"
                      onClick={() => setActiveModal("projects")}
                    >
                      <i className="fas fa-eye"></i> Lihat Project
                    </button>
                  </div>
                </>
              )}
            </Box>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Box title={`Vouchers (Total: ${meta.count || 0})`} loading={loadingVouchers}>
              {errorVouchers && <div className="alert alert-danger">{errorVouchers}</div>}
              <AlertBox {...alert} setAlert={setAlert} />
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Pencarian</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email User Aplikasi / No. Registrasi ..."
                      value={formFilter.q}
                      onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
                <div className="col-auto ml-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => setActiveModal("download")}
                    style={{ marginTop: "32px" }}
                  >
                    <i className="fas fa-download"></i> Unduh Data
                  </button>
                </div>
              </div>
              <table className="table table-sm table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th>Voucher Code</th>
                    <th>Waktu Klaim</th>
                    <th>User Apps Email</th>
                    <th>No. Registrasi</th>
                    <th>Tambahan Masa Aktif (hari)</th>
                  </tr>
                </thead>
                <tbody>
                  {vouchers.length === 0 && (
                    <tr>
                      <td colSpan={5} className="text-center">
                        Tidak ada data
                      </td>
                    </tr>
                  )}
                  {vouchers.map((voucher, index) => (
                    <tr key={index}>
                      <td>{voucher.voucher_code}</td>
                      <td>
                        {voucher.issued_at
                          ? moment(voucher.issued_at).format("D MMMM YYYY HH:mm")
                          : "-"}
                      </td>
                      <td>{voucher.user?.email || "-"}</td>
                      <td>{voucher.customer?.registration_number || "-"}</td>
                      <td>{voucher.extra_days ? voucher.extra_days : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>

      <ModalDownloadCampaignVouchers
        show={activeModal === "download"}
        campaignId={id}
        onClose={() => setActiveModal(null)}
        onSuccess={(message) => {
          setActiveModal(null);
          setAlert({ show: true, message, type: "success" });
        }}
      />
      <ModalCampaignProjects
        show={activeModal === "projects"}
        projects={campaign?.projects || []}
        onClose={() => setActiveModal(null)}
      />
    </MainLayout>
  );
}

function BackToCampaignLink() {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to={`/campaign`}>
            <i className="fa-regular fa-circle-left"></i> Kembali ke Halaman Campaign
          </Link>
        </li>
      </ol>
    </nav>
  );
}
